import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);

  params.Descripcion &&
    (path = `${path !== '' ? `${path}&` : ''}Descripcion=${params.Descripcion}`);
  if (params.Activo !== null) {
    path = `${path !== '' ? `${path}&` : ''}Activo=${params.Activo}`;
  }

  return path;
};
